import { AnswerButton } from '../AnswerButton/AnswerButton'
import { useTaskHomeWork } from '../hooks/useTaskHomeWork';
import { useDragAndDrop } from './hooks/useDragAndDrop';
import { useCartActions } from './hooks/useCartActions';
import { initializeBaskets } from './utils/initializeBaskets';
import { initializeOptions } from './utils/initializeOptions';
import { getUsedAnswerIds } from './utils/getUsedAnswerIds';
import { Wpapper } from './components/Wpapper';
import { Options } from './components/Options';
import { Baskets } from './components/Baskets';
import { useEffect, useMemo, useState } from 'react';
import { CorrectAnswers } from './components/CorrectAnswers';
import { jsonConvert } from '@/helpers/jsonConvert';
import { formateTime } from '@/helpers/formateTime';
import common from "./common.module.css";

export const Basket = ({ type, ...props }) => {
  switch (type) {
    case 'decided': return <Decided {...props} />
    case 'correction': return <Correction {...props} />
    default: return <Task type={type} hist={props?.hist}  {...props} />
  }
}
const Correction = (props) => {
  
  const [options, setOptions] = useState(
    initializeOptions(
      {
        answerOptions: props.answer_options
      }
    )
  );

  const [baskets, setBaskets] = useState(
    initializeBaskets(
      {
        baskets: props.baskets,
        hasAnswers: false,
        answerOptions: props.answer_options
      }
    )
  )

  let optionsText = options.filter((el) => el.type === 'text');
  let optionsImg = options.filter((el) => el.type === 'img')

  return ( 
    <Wpapper>
        <Options
          {...{
            optionsText,
            optionsImg,
          }}
          isInteractive = {false}
        />
        <Baskets
          {...{
            baskets,
          }}
          isInteractive = {false}
        />
    </Wpapper>
  )
}

const Decided = ({ ...props }) => {
  const answer = jsonConvert(props?.params?.result?.answer, 'json')
  const correctAnswer = jsonConvert(props?.params?.result?.correct_answer, 'json')

  const idsOptionsThatHaveAlreadyBeenUsedToAnswer = useMemo(
      () => getUsedAnswerIds({
        answers: answer
      }),
    []
  ); //хранит id всех вариантов ответа, которые уже использованы в ответе учащимся


  const [options, setOptions] = useState(
    initializeOptions(
      {
        answerOptions: props.answer_options,
        idsOptionsThatHaveAlreadyBeenUsedToAnswer
      }
    )
  );

  const [baskets, setBaskets] = useState(
    initializeBaskets(
      {
        baskets: props.baskets,
        hasAnswers: !!idsOptionsThatHaveAlreadyBeenUsedToAnswer, // если есть хотя бы один вараинт ответа, который учащийся помещал в корзину
        answers: answer,
        answerOptions: props.answer_options
      }
    )
  )

  let optionsText = options.filter((el) => el.type === 'text');
  let optionsImg = options.filter((el) => el.type === 'img')

  return ( 
    <Wpapper>
        <Options
          {...{
            optionsText,
            optionsImg,
          }}
          isInteractive = {false}
        />
        <Baskets
          {...{
            baskets,
            correctAnswer
          }}
          isInteractive = {false}
        />

        {
          correctAnswer && (
            <CorrectAnswers 
              correctAnswer={correctAnswer}
              baskets={props.baskets}
              answerOptions={props.answer_options}
            />
          )
        }

        {props?.params?.result?.time_spent &&
          <div className={common.estimation}>
            <span className={common.boobleSpent}>Потрачено время</span>
            <span className={common.boobleSpent}> {formateTime(props?.params?.result?.time_spent)}</span>
          </div>
        }
    </Wpapper>
  )
}

const Task = ({ hist, params, userRole, ...props }) => {
  const { onAnswer, answer, status, hint, video, videoType, correctAnswer } = useTaskHomeWork(params,  {...props, type: 'obj'});

  const idsOptionsThatHaveAlreadyBeenUsedToAnswer = useMemo(
    () => getUsedAnswerIds({
      answers: answer.get
    }),
    []
  ); //хранит id всех вариантов ответа, которые уже использованы в ответе учащимся


  const [options, setOptions] = useState(
    initializeOptions(
      {
        answerOptions: props.answer_options,
        idsOptionsThatHaveAlreadyBeenUsedToAnswer
      }
    )
  );

  const [baskets, setBaskets] = useState(
    initializeBaskets(
      {
        baskets: props.baskets,
        hasAnswers: !!idsOptionsThatHaveAlreadyBeenUsedToAnswer, // если есть хотя бы один вараинт ответа, который учащийся помещал в корзину
        answers: answer.get,
        answerOptions: props.answer_options
      }
    )
  )

  useEffect(() => {
    if(status > 4) return;
    
    if(options?.length === 0){// если все варианты разнесли по корзинам
      const studentAnswer = {};
      baskets.forEach(basket => {
        studentAnswer[basket.id] = basket.options.map((option) => option.id)
      });
      answer.set(jsonConvert(studentAnswer))
    }
    else{ // иначе устанавливаем пустой ответ, чтобы нельзя было ответить на задачу
      answer.set('')
    }
  }, [options, baskets])  

  const [cuttentOptionByClick, setCuttentOptionByClick] = useState(null);

  const {
    dragStartHandler,
    dragEndHandler,
    dragOvertHandler,
    dropHandler,
  } = useDragAndDrop({ setOptions, setBaskets, setCuttentOptionByClick }); //для логики перетаскивания
  
  const { removeFromCart, addFromCart } = useCartActions({
    cuttentOptionByClick,
    setCuttentOptionByClick,
    setOptions,
    setBaskets,
  }); // для логики перемещения по клику

  let optionsText = options.filter((el) => el.type === 'text');
  let optionsImg = options.filter((el) => el.type === 'img')
  
  return ( 
    <Wpapper>
        <Options
          {...{
            optionsText,
            optionsImg,
            dragOvertHandler,
            dropHandler,
            dragEndHandler,
            removeFromCart,
            status,
            setCuttentOptionByClick,
            cuttentOptionByClick,
            dragStartHandler,
          }}
          isInteractive = {status < 5 && userRole !== 'parent'}
        />
        <Baskets
          {...{
            baskets,
            dragOvertHandler,
            dropHandler,
            dragEndHandler,
            addFromCart,
            dragStartHandler,
            status,
            setCuttentOptionByClick,
            cuttentOptionByClick,
            correctAnswer,
          }}
          isInteractive = {status < 5 && userRole !== 'parent'}
        />

        {
          correctAnswer && hist !== '?redo=ok' &&  params.type !== 'control' && (
            <CorrectAnswers 
              correctAnswer={correctAnswer}
              baskets={props.baskets}
              answerOptions={props.answer_options}
            />
          )
        }

        <AnswerButton hintForChild={params.hintForChild} hintAfterAllAttempts={props.hint_after_all_attempts} {...{ status, onAnswer, hint, video, videoType }} />
    </Wpapper>
  )
}